import { useQuery } from "@apollo/client";

import {
    MetricField,
    MyLensesAssetType,
    ReportingGranularity,
    ReportingSortDirection,
} from "../../gql-generated/types";
import {
    type GetOrganicStatsQuery,
    type GetOrganicStatsQueryVariables,
    getOrganicStats,
} from "../../lens-insights/api/queries";
import { generateFieldsList } from "../../lens-insights/generators";
import { type ApolloResult } from "../../shared/models";
import { statsFields } from "../models";

export const useLensStatsQuery = (lensId: string): ApolloResult<{ data: GetOrganicStatsQuery | undefined }> => {
    const { loading, error, data } = useQuery<GetOrganicStatsQuery, GetOrganicStatsQueryVariables>(getOrganicStats, {
        variables: {
            assetType: MyLensesAssetType.User,
            lensId,
            breakdownAssetType: MyLensesAssetType.Lens,
            granularity: ReportingGranularity.Lifetime,
            fieldsList: generateFieldsList(statsFields),
            startTime: null,
            endTime: null,
            sortBy: MetricField.MetricFieldUnset,
            sortDirection: ReportingSortDirection.SortDirectionUnset,
            limit: 0,
        },
    });

    return { data, error, loading };
};
